module.exports = __webpack_public_path__ + "img/113.1.8f28adb1.jpg";